import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { ProblemsSection } from './components/ProblemsSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentsSection } from './components/ContentsSection';
import { SampleCarousel } from './components/SampleCarousel';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { SiteFooter } from './components/SiteFooter';
import { StickyOfferBar } from './components/StickyOfferBar';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-white pb-[72px] font-sans text-ink" data-id="element-0" data-mp="23ujjma5idj2g">
      <main data-id="element-1" data-mp="3ij63w8owfj7c">
        <Hero data-id="element-2" data-mp="3ijfthv617oci" />
        <TrustStrip data-id="element-3" data-mp="3ihv0i9zd8dgr" />
        <ProblemsSection data-id="element-4" data-mp="3mlj6wpc9h30f" />
        <SolutionSection data-id="element-5" data-mp="3mkrchhuehbbq" />
        <ContentsSection data-id="element-6" data-mp="3mjzuj9tq7c3x" />
        <SampleCarousel data-id="element-7" data-mp="3mj6hjr46bqdc" />
        <BonusesSection data-id="element-8" data-mp="3rcj2nr9n9f1c" />
        <OfferSection data-id="element-9" data-mp="3rdar8i4tqci4" />
        <GuaranteeSection data-id="element-10" data-mp="3rd1azm9kzjpm" />
        <FaqSection data-id="element-11" data-mp="5yk6vxnnffx" />
        <ClosingSection data-id="element-12" data-mp="6hr7hlrojf6" />
      </main>
      <SiteFooter data-id="element-13" data-mp="5gfrc0u9uwx" />
      <StickyOfferBar data-id="element-14" data-mp="82kl3wchwbg" />
    </div>;
}